import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSquareBehindSquare1"><Path d="M15.25 8.75V5C15.25 3.75736 14.2426 2.75 13 2.75H5C3.75736 2.75 2.75 3.75736 2.75 5V13C2.75 14.2426 3.75736 15.25 5 15.25H8.75M11 8.75H19C20.2426 8.75 21.25 9.75736 21.25 11V19C21.25 20.2426 20.2426 21.25 19 21.25H11C9.75736 21.25 8.75 20.2426 8.75 19V11C8.75 9.75736 9.75736 8.75 11 8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
